import styled from "styled-components";

const MyDiv = styled.div`
@keyframes blinkToday {
  0% {
    background: #FFF6ED;
  }
  50% {
    background: #FDEAD7;
  }
  100% {
    background: #FFF6ED;
  }
}

@keyframes blinkApproaching {
  0% {
    background: #FEF3F2;
  }
  50% {
    background: #FEE4E2;
  }
  100% {
    background: #FEF3F2;
  }
}

/* Table rows */
.blink-today td {
  animation: blinkToday 1.2s infinite;
  color: #C4320A !important;
  font-weight: 500;
}

.blink-approaching td {
  animation: blinkApproaching 1.2s infinite;
  color: #B42318 !important;
  font-weight: 500;
}

/* Card/Grid */
.blink-today,
.blink-today * {
  animation: blinkToday 1.2s infinite;
  color: #C4320A !important;
}

.blink-approaching,
.blink-approaching * {
  animation: blinkApproaching 1.2s infinite;
  color: #B42318 !important;
}

.expired-row,
.expired-row * {
  background: #FEE2E2 !important;
  color: #DC2626 !important;
}
`;

export default MyDiv;
